import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loseLife } from '../actions';

class GameTile extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
	    selected: false
	  };
	}
	clickTile = (char) =>{
		this.setState({selected: true})
		if(this.props.correct){
			this.props.completeColumn(char)
		} else {
			if(this.props.lives >= 1){
				this.props.loseLife();
				this.props.showMistake(this.props.character, this.props.meaning)
			}
		}
	}
	render(){
		//check classes to apply
		const isComplete = this.props.completed ? " complete" : ""
		const isHidden = this.props.completed && !this.props.correct ? ' hide' : ' ';
		const isIncorrectSelected = !this.props.correct && this.state.selected ? " incorrect" : "";
		const first = this.props.first === true ? " first" : "";
		const last = this.props.last === true ? " last" : "";
		let minipad = ""
		if(this.props.minipad === 4) {
			minipad = ' minipad'
		}
		if(this.props.minipad === 5) {
			minipad = ' minipad-double'
		}
		const className = "game-tile" + isComplete + isIncorrectSelected + isHidden + first + last + minipad ;
		return(
			<div className={className} onClick={() => !this.props.completed ? this.clickTile(this.props.character) : ""} >{ this.props.character }</div>
			)
	}
}

const mapStateToProps = ({ GameOptions }) => {
	return {
		lives: GameOptions.lives
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		loseLife: () => {
			dispatch(loseLife())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(GameTile);



// WEBPACK FOOTER //
// ./src/components/gametile.js